import {useQuery, useMutation} from '@apollo/client'
import {Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {GET_SYSTEM_EMAIL_SETTINGS} from '../../../gql/queries/emailSettingsQuery'
import {SEND_TEST_EMAIL, UPDATE_SYSTEM_EMAIL_SETTINGS} from '../../../gql/mutations/emailSettingsMutations'
import {EmailSettingsForm, IEmailSettingsValues} from '../../shared/EmailSettingsForm'

import {defineMessages, useIntl} from 'react-intl'

const M = defineMessages({
  introSettings: {
    id: 'admin.policytoolsSettings.email.introSettings',
    defaultMessage:
      'Default system configuration: sender and signature used when an Organization or User doesn’t have its own override.',
  },
  saved: {id: 'admin.organizations.email.toast.settingsSaved', defaultMessage: 'Email Settings saved'},
  errSaving: {id: 'admin.organizations.email.error.savingSettings', defaultMessage: 'Error saving Email Settings'},
  errTest: {
    id: 'admin.organizations.email.error.test',
    defaultMessage: 'Error sending test email',
  },
  testSent: {
    id: 'admin.organizations.email.toast.testSent',
    defaultMessage: 'Test email sent to {email}',
  },
})

export const EmailSettingsTab = () => {
  const intl = useIntl()
  const {data, loading, refetch} = useQuery(GET_SYSTEM_EMAIL_SETTINGS, {fetchPolicy: 'network-only'})
  const [updateSystemEmailSettings, {loading: saving}] = useMutation(UPDATE_SYSTEM_EMAIL_SETTINGS)
  const [sendTestEmail, {loading: sendingTestEmail}] = useMutation(SEND_TEST_EMAIL)

  const settings = data?.systemEmailSettings

  const handleSendTestEmail = async (toEmail: string) => {
    try {
      const res = await sendTestEmail({variables: {toEmail}})
      const result = res.data?.sendTestEmail
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || intl.formatMessage(M.errTest))
        return
      }
      toast.success(intl.formatMessage(M.testSent, {email: toEmail}))
    } catch (err: any) {
      toast.error(err.message || intl.formatMessage(M.errTest))
    }
  }

  const handleSave = async (input: IEmailSettingsValues) => {
    try {
      const res = await updateSystemEmailSettings({variables: {input}})
      const result = res.data?.updateSystemEmailSettings
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || intl.formatMessage(M.errSaving))
        return
      }
      toast.success(intl.formatMessage(M.saved))
      refetch()
    } catch (err: any) {
      toast.error(err.message || intl.formatMessage(M.errSaving))
    }
  }

  if (loading) {
    return (
      <div className='text-center py-6'>
        <Spinner animation='border' size='sm' />
      </div>
    )
  }

  return (
    <div>
      <p className='text-muted mb-4' style={{fontSize: '0.85rem'}}>
        {intl.formatMessage(M.introSettings)}
      </p>
      <EmailSettingsForm
        values={settings}
        showInheritance={false}
        saving={saving}
        onSave={handleSave}
        onSendTestEmail={handleSendTestEmail}
        sendingTestEmail={sendingTestEmail}
      />
    </div>
  )
}
